import React, { ChangeEvent, useCallback, useMemo, useRef, useState } from 'react';
import { FunctionComponent } from 'react';
import { useDispatch } from 'react-redux';
import { userSelectors } from '../../../../../../../../app/resource/user/user.selectors';
import { clearTaskModalStatuses } from '../../../../../../../../app/task-modals/task-modals.actions';
import { taskModalSelectors } from '../../../../../../../../app/task-modals/task-modals.selectors';
import useOutsideClick from '../../../../../../../../utils/click.utils';
import { useSelectWithParams } from '../../../../../../../../utils/selector.utils';
import { IReducedUsers } from '../../../../../../UserPage/UserList/types';
import { reduceUsersByFirstName } from '../../../../../../../../utils/user.utils';
import { Member } from './Member';
import { IMembersMenuProps } from './types';
import { taskSimpleSelectors } from '../../../../../../../../app/resource/task-simple/task-simple.selectors';
import { IUser } from '../../../../../../../../app/resource/user/user.types';
import { ITaskSimple } from '../../../../../../../../app/resource/task-simple/task-simple.types';
import { updateTaskSimple } from '../../../../../../../../app/page/page-storage/tasks-simple/tasks-simple.actions';
import { useApiRequestState } from '../../../../../../../../utils/api.utils';

export const MembersMenu: FunctionComponent<IMembersMenuProps> = ({
  userIds,
  dropRight,
  closeMenu,
  taskId,
  triggerRef,
}) => {
  const task = useSelectWithParams(taskSimpleSelectors.selectResourceById, taskId ?? '') as ITaskSimple;
  const showLoader = false;
  const [showUpdateLoader] = useApiRequestState('updateTaskApi');
  let users = useSelectWithParams(userSelectors.selectResourcesById, userIds) as IUser[];
  users = users.filter((user) => !user.deleted || task.members.includes(user.id));

  /*
  const allUserIds = useSelect(userSelectors.selectResourceIds);
  const nonMemberIds = allUserIds.filter((id) => !userIds.includes(id));
  let nonMembers = useSelectWithParams(userSelectors.selectResourcesById, nonMemberIds) as IUser[];
  nonMembers = nonMembers.filter((user) => user.deleted === false || task.members.includes(user.id));
  */

  const [searchParam, setSearchParam] = useState<string>('');
  const [isErrorMode, setIsErrorMode] = useState<boolean>(false);

  const setErrorTimeout = () => {
    setIsErrorMode(true);
    setTimeout(() => {
      setIsErrorMode(false);
    }, 4000);
  };

  const reducedUsersByFirstName = useMemo<IReducedUsers>(() => reduceUsersByFirstName(users, searchParam), [
    users,
    searchParam,
  ]);
  /*
  const reduceNonMembersByFirstName = useCallback(
    () =>
      nonMembers.reduce((prev, curr) => {
        if (!curr || !curr.firstName.toLowerCase().includes(searchParam.toLowerCase())) {
          return { ...prev };
        }
        if (!prev[curr.firstName[0]]) {
          prev[curr.firstName[0]] = [];
        }
        prev[curr.firstName[0]] = [...prev[curr.firstName[0]], curr];
        return { ...prev };
      }, {} as IReducedUsers),
    [searchParam, nonMembers],
  );
  */

  const onFilter = useCallback((event: ChangeEvent<HTMLInputElement>) => {
    setSearchParam(event.target.value);
  }, []);
  const dispatch = useDispatch();
  const open = useSelectWithParams(taskModalSelectors.selectTaskModalStatus, 'taskMembers');
  const handleClickOutside = () => {
    if (open) {
      dispatch(clearTaskModalStatuses());
    }
  };

  const onSelectAllMembers = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { checked } = event.target;
    dispatch(
      updateTaskSimple(task.id, {
        members: checked ? userIds : [],
      }),
    );
  };

  const isActionItem = task?.showInTasks === '1';
  const allMembersSelected = task.members.length === userIds.length;
  const popupRef = useRef<HTMLDivElement>(null);

  useOutsideClick({
    callback: handleClickOutside,
    refs: [popupRef, triggerRef],
    enabled: open,
  });
  return (
    <div
      className={dropRight ? 'dropdown-menu drop-right' : 'dropdown-menu'}
      style={showLoader ? { pointerEvents: 'none' } : {}}
    >
      <div className="mini-popup" ref={popupRef}>
        <div className="mini-popup-header">
          Members
          <span className="close_mini_popup" onClick={closeMenu}>
            ×
          </span>
        </div>
        {isErrorMode && (
          <div style={{ color: 'red', fontSize: '10px', marginBottom: '5px' }}>
            Cannot remove all members in an action item
          </div>
        )}
        <div className="mini-popup-body">
          <form action="" className="form-search-contacts">
            <input type="text" className="small-input" placeholder="Search members" onChange={onFilter} />
          </form>
          <div className="mt-2 mb-2">
            {showUpdateLoader || !task?.members ? (
              <span className="css-loader mr-2" style={{ height: 12, width: 12 }}></span>
            ) : (
              <input
                type="checkbox"
                id="check-all-members"
                checked={allMembersSelected}
                onChange={onSelectAllMembers}
                disabled={allMembersSelected && isActionItem}
              />
            )}
            <label htmlFor="check-all-members">
              {allMembersSelected ? 'Deselect all members' : 'Select all members'}
            </label>
          </div>
          <label className="mb-1 mt-1 d-block">Board members</label>
          {users && taskId && (
            <div className="list-members">
              {Object.keys(reducedUsersByFirstName).map((letter) => (
                <div key={letter}>
                  {reducedUsersByFirstName[letter].map(
                    (user) =>
                      user && (
                        <Member
                          userId={user.id}
                          key={`memberId-${user.id}`}
                          taskId={taskId}
                          setIsErrorMode={setErrorTimeout}
                        />
                      ),
                  )}
                </div>
              ))}
            </div>
          )}
          {/*
              <hr></hr>
              <label className="mb-1 mt-1 d-block">Non meeting</label>
              {nonMembers && taskId && (
                <div className="list-members">
                  {Object.keys(reduceNonMembersByFirstName()).map((letter) => (
                    <div key={letter}>
                      {reduceNonMembersByFirstName()[letter].map(
                        (user) => user && <Member userId={user.id} key={`memberId-${user.id}`} taskId={taskId} />,
                      )}
                    </div>
                  ))}
                </div>
              )}
            */}
        </div>
      </div>
    </div>
  );
};
